import { library } from "@fortawesome/fontawesome-svg-core";

import {
	faTelegram
} from '@fortawesome/free-brands-svg-icons'
import {
	faChevronLeft,
	faSave,
	faPen,
	faPlus,
	faRocket,
	faTrash,
	faUser,
	faSignInAlt,
	faCog
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(
	faTelegram,
	faChevronLeft,
	faSave,
	faPen,
	faPlus,
	faRocket,
	faTrash,
	faUser,
	faSignInAlt,
	faCog
);

export { FontAwesomeIcon };
